// extracted by mini-css-extract-plugin
module.exports = {"line":"CrosshatchLine_line__SPcjL"};